// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1660":"9aa7e041","4539":"9aa7e041","5378":"edb30248"}[chunkId] + ".chunk.css";
};